import React, { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getValidationSchema } from './validationSchema';
import { defaultForm } from './formStructure';
import { usePageContext, useSleeperDataContext } from '@sleepunique/context';

export interface Props {
  children: ReactNode;
}

export default function FormProviderWrapper({ children }: Props) {
  const defaultValues = defaultForm;
  const { page } = usePageContext();
  const { currentSleeper } = useSleeperDataContext();

  const methods = useForm({ defaultValues, resolver: yupResolver(getValidationSchema(page, currentSleeper.sleeper)) });

  const {
    formState,
    formState: { errors },
    getValues,
  } = methods;

  return <FormProvider {...methods}>{children}</FormProvider>;
}
